module.exports = __webpack_public_path__ + "assets/location_searching.2cb83bbf.svg";